module.exports = __webpack_public_path__ + "img/logo_gray.8669e9f6.svg";